import { ThunkType } from "../../../../core/store/reducers";
import { getAntiLaunderingReport } from "../api/getAntiLaunderingReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../amlaunderingDataSlice";

export const downloadAntiLndReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.reports.antiLaundering;
  const user = store.data.auth.current.user;
  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getAntiLaunderingReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "AntiMnyLndComm.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
